module.exports = __webpack_public_path__ + "static/img/4.d6f2a7d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/zh/4.png
// module id = z/Hy
// module chunks = 0